import type { SubTemplateProps } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'

export function Gallery2SlideTemplate({ display, controls, slots }: SubTemplateProps) {
  const photo = display.permissions.canViewContent && !display.access.isContentLocked
    ? display.media.primaryAttachment
    : undefined
  const photoSrc = photo?.src || photo?.thumbSrc
  return (
    <>
      <div className={`md-subs-gallery-row relative m-0 flex min-h-[335px] items-center justify-center overflow-hidden bg-[#0a0a0a] text-white${display.isChecked ? ' md-subs-gallery-row--checked ring-2 ring-inset ring-white' : ''}`}>
        <div className="md-subs-gallery-photo absolute inset-0 bg-gradient-to-br from-[#1a1a2e] via-[#16213e] to-[#0f3460]" />
        {photoSrc ? <img className="absolute inset-0 h-full w-full object-cover" src={photoSrc} alt={photo.title || photo.filename || display.title} /> : null}
        <div className="md-subs-gallery-watermark absolute text-[72px] font-bold tracking-[0.2em] text-white/10">PHOTO</div>
        <div className="md-subs-gallery-title absolute left-5 top-5 rounded-lg bg-black/60 px-4 py-2 backdrop-blur [&_.md-sub-title-link]:text-white">
          {controls.content.title}
        </div>
        <div className="md-subs-gallery-caption absolute inset-x-5 bottom-5 rounded-lg bg-black/60 p-3 backdrop-blur">
          <div className="leading-[1.4] text-white/90 [&_.md-sub-text]:whitespace-normal [&_.md-sub-text]:text-white/90">{controls.content.text}</div>
          <div className="mt-2 flex items-center gap-3 text-sm text-white/70">
            {controls.content.time}
            {controls.links.answers}
            {controls.links.submsges}
            {controls.actions.check}
            {controls.actions.favorite}
            {controls.actions.quickReply}
          </div>
        </div>
      </div>
      {slots.allChildren}
    </>
  )
}
